"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { InspectorProps } from "../../lib/inspector";
import {
  PoiImageHotspot,
  type PoiImageHotspotProps,
} from "./poi-image-hotspot";

export type PoiImageHotspotInspectorProps = InspectorProps<"container">;

export function PoiImageHotspotPreview(props: Readonly<PoiImageHotspotProps>) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  return (
    <PoiImageHotspot
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
      }}
    />
  );
}
